var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-background"},[_c('div',{staticClass:"card"},[_c('card-panel')],1),_c('div',{staticClass:"container-target"},[_c('active-goal',{staticClass:"mb-6"}),_c('task-panel')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }